import { render, staticRenderFns } from "./detailsdialog.vue?vue&type=template&id=71aa592e&scoped=true"
import script from "./detailsdialog.vue?vue&type=script&lang=js"
export * from "./detailsdialog.vue?vue&type=script&lang=js"
import style0 from "./detailsdialog.vue?vue&type=style&index=0&id=71aa592e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa592e",
  null
  
)

export default component.exports